var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',{staticClass:"justify-center mt-n5"},[_vm._v(" "+_vm._s(_vm.countString)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }